import * as React from "react"
const SvgComponent = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="#D92D20"
      strokeLinecap="round"
      strokeWidth={1.2}
      d="m16.25 4.582-.516 8.354c-.132 2.135-.198 3.202-.733 3.97-.265.379-.605.699-1 .94-.8.486-1.868.486-4.007.486-2.141 0-3.212 0-4.011-.488a3.334 3.334 0 0 1-1-.941c-.536-.769-.6-1.837-.73-3.975L3.75 4.582"
    />
    <path
      stroke="#D92D20"
      strokeLinecap="round"
      strokeWidth={1.2}
      d="M2.5 4.583h15m-4.12 0-.57-1.174c-.377-.78-.566-1.17-.892-1.412a1.67 1.67 0 0 0-.229-.144c-.36-.187-.794-.187-1.66-.187-.888 0-1.332 0-1.7.195a1.667 1.667 0 0 0-.231.15c-.33.252-.514.656-.883 1.464l-.504 1.108M7.918 13.75v-5M12.082 13.75v-5"
    />
  </svg>
)
export default SvgComponent
